// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","270":"component---gatsby-theme-bwsportfolio-src-pages-index-mdx"}[chunkId] + "-" + {"218":"69b6cc21e3c9f4fbca73","270":"14ef836a354f15ca9ade"}[chunkId] + ".js";
};